import { render, staticRenderFns } from "./RequestsView.vue?vue&type=template&id=2230dc5e&scoped=true"
import script from "./RequestsView.vue?vue&type=script&lang=js"
export * from "./RequestsView.vue?vue&type=script&lang=js"
import style0 from "./RequestsView.vue?vue&type=style&index=0&id=2230dc5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2230dc5e",
  null
  
)

export default component.exports